import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-2xl text-center" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2" }
const _hoisted_3 = { class: "mt-10 space-y-4" }

import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import { PageBlock } from "@/views/blocks/PageBlock.interface";
import { CenteredContactProps } from "./CenteredContactProps";
import { computed } from "vue";
import EditableElement from "@/views/page/EditableElement.vue";
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";
import FormField from "../components/form-field/FormField.vue";
import FormMessages from "../components/form-messages/FormMessages.vue";
import SubmitButton from "../components/submit-button/SubmitButton.vue";
import PrivacyPolicy from "../components/privacy-policy/PrivacyPolicy.vue";
import { useContactForm } from "../common/useContactForm";


export default /*@__PURE__*/_defineComponent({
  __name: 'CenteredContact',
  props: {
    block: {},
    pageColors: {},
    pageUuid: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

const { agreed, formSubmitted, isSubmitting, showSuccessMessage, showErrorMessage, handleSubmit } =
    useContactForm({
        // hookUrl: dataValues.value.submitButton.data.hookUrl,
        privacyPolicyHidden: dataValues.value.privacyPolicy.isHidden,
        validationMessage: dataValues.value.privacyPolicy.data.validationMessage,
        successMessage: dataValues.value.submitButton.data.successMessage,
        errorMessage: dataValues.value.submitButton.data.errorMessage,
        pageUuid: props.pageUuid,
        sectionId: props.block.id,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    class: "relative isolate",
    backgroundColor: styleValues.value.background
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!dataValues.value.title.isHidden)
              ? (_openBlock(), _createBlock(EditableElement, {
                  key: 0,
                  blockId: _ctx.block.id,
                  "field-name": "title"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Heading, _mergeProps(dataValues.value.title.data, {
                      textColor: styleValues.value.text,
                      class: "text-4xl sm:text-5xl"
                    }), null, 16, ["textColor"])
                  ]),
                  _: 1
                }, 8, ["blockId"]))
              : _createCommentVNode("", true),
            (!dataValues.value.description.isHidden)
              ? (_openBlock(), _createBlock(EditableElement, {
                  key: 1,
                  blockId: _ctx.block.id,
                  "field-name": "description"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Paragraph, _mergeProps(dataValues.value.description.data, {
                      textColor: styleValues.value.text,
                      class: "mt-6 text-lg/8 opacity-70"
                    }), null, 16, ["textColor"])
                  ]),
                  _: 1
                }, 8, ["blockId"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("form", {
            class: "mx-auto mt-16 max-w-xl sm:mt-20",
            onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(handleSubmit) && _unref(handleSubmit)(...args)))
          }, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.fields.data.items, (field) => {
                return (_openBlock(), _createBlock(EditableElement, {
                  key: field.id,
                  blockId: _ctx.block.id,
                  "field-name": `fields_${field.id}`,
                  hideable: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(FormField, _mergeProps({ ref_for: true }, field, {
                      "label-color": styleValues.value.text,
                      "accent-color": styleValues.value.brand,
                      "border-color": styleValues.value.border
                    }), null, 16, ["label-color", "accent-color", "border-color"])
                  ]),
                  _: 2
                }, 1032, ["blockId", "field-name"]))
              }), 128)),
              (!dataValues.value.privacyPolicy.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    "field-name": "privacyPolicy"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(PrivacyPolicy, _mergeProps(dataValues.value.privacyPolicy.data, {
                        "accent-color": styleValues.value.brand,
                        agreed: _unref(agreed),
                        "onUpdate:agreed": _cache[0] || (_cache[0] = ($event: any) => (_isRef(agreed) ? (agreed).value = $event : null))
                      }), null, 16, ["accent-color", "agreed"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              (!dataValues.value.submitButton.isHidden)
                ? (_openBlock(), _createBlock(EditableElement, {
                    key: 0,
                    blockId: _ctx.block.id,
                    "field-name": "submitButton"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SubmitButton, {
                        label: dataValues.value.submitButton.data.label,
                        "text-color": '#ffffff',
                        "background-color": styleValues.value.brand,
                        "is-submitting": _unref(isSubmitting)
                      }, null, 8, ["label", "background-color", "is-submitting"])
                    ]),
                    _: 1
                  }, 8, ["blockId"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(FormMessages, {
              formSubmitted: _unref(formSubmitted),
              agreed: _unref(agreed),
              validationMessage: dataValues.value.privacyPolicy.data.validationMessage,
              successMessage: dataValues.value.submitButton.data.successMessage,
              errorMessage: dataValues.value.submitButton.data.errorMessage,
              showSuccessMessage: _unref(showSuccessMessage),
              showErrorMessage: _unref(showErrorMessage)
            }, null, 8, ["formSubmitted", "agreed", "validationMessage", "successMessage", "errorMessage", "showSuccessMessage", "showErrorMessage"])
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "backgroundColor"]))
}
}

})